import React from 'react';
import SEOHead from './SEOHead';
import LandingFooter from './LandingFooter';
import './landing.css';

const serif = { fontFamily: '"DM Serif Display", Georgia, serif' };
const ACCENT = '#1a5fff';

const SECTIONS = [
  { title: '1. Information We Collect', body: [
    'We collect information you provide directly when you register an account, add employees, or contact us. This includes names, email addresses, phone numbers, job titles, salary details, and attendance records necessary to operate the HRMS platform.',
    'Location data: With your permission, our mobile app accesses your device\'s precise (GPS) location at the time you check in or check out. This is collected only when you actively mark attendance and is used to verify that attendance is being marked from an approved work location. We do not track or collect your location in the background or at any other time.',
    'We also collect usage data (pages visited, features used, session duration) and technical data (IP address, browser type, device) automatically when you use our platform.',
  ]},
  { title: '2. How We Use Your Information', body: [
    'Your data is used solely to provide and improve the DigiHR platform. Specific uses include: processing payroll calculations, generating payslips, verifying GPS-based attendance location, sending product notifications, and responding to support requests.',
    'Location data collected during check-in/check-out is used exclusively to validate attendance records and is stored securely alongside the associated attendance entry. It is not shared with third parties for advertising or any purpose unrelated to attendance verification.',
    'We use aggregated, anonymised data to improve product features. We never use individual employee data for advertising purposes.',
  ]},
  { title: '3. Data Sharing', body: [
    'We do not sell your data. We share data only with trusted sub-processors (cloud hosting, payment processing, email delivery) who are contractually bound to handle it under the same standards we apply. A full list of sub-processors is available on request.',
  ]},
  { title: '4. Data Security', body: [
    'All data is encrypted at rest (AES-256) and in transit (TLS 1.3). We are SOC 2 Type II certified and conduct annual third-party penetration tests. Access to customer data by Sciverse employees is role-restricted and fully logged.',
  ]},
  { title: '5. Data Retention', body: [
    'We retain your account data for as long as your subscription is active and for up to 7 years thereafter to meet statutory compliance requirements under Indian law (including the Companies Act and Income Tax Act). You may request deletion of non-statutory data at any time.',
  ]},
  { title: '6. Your Rights', body: [
    'You have the right to access, correct, or delete personal data we hold about you, subject to statutory retention requirements. To exercise these rights, email us at privacy@digihr.in. We will respond within 30 days.',
  ]},
  { title: '7. Cookies', body: [
    'We use essential cookies to keep you logged in and remember your preferences. We use analytics cookies (anonymised) to understand how the product is used. You can disable non-essential cookies in your browser settings at any time.',
  ]},
  { title: '8. Changes to This Policy', body: [
    'We may update this policy from time to time. Material changes will be communicated via email and an in-app notification at least 14 days before they take effect.',
  ]},
];

const PrivacyPolicy = () => (
  <>
    <SEOHead
      title="Privacy Policy — DigiHR"
      description="Read DigiHR's privacy policy to understand how Sciverse Solutions Pvt. Ltd. collects, uses and protects your data on our cloud HR management platform."
      canonical="/privacy-policy"
    />

    {/* Page Hero */}
    <section style={{ padding: '60px 5% 52px', background: 'linear-gradient(160deg,#f0f4ff 0%,#ffffff 100%)', borderBottom: '1px solid #e4e7ed' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 12, fontWeight: 500, color: ACCENT, letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 12 }}>Legal</div>
        <h1 style={{ ...serif, fontSize: 'clamp(36px,4.5vw,56px)', lineHeight: 1.1, letterSpacing: '-.03em', color: '#0d1117', maxWidth: 600, marginBottom: 16 }}>
          Privacy <em style={{ fontStyle: 'italic', color: ACCENT }}>Policy</em>
        </h1>
        <p style={{ fontSize: 17, color: '#3a3f4a', lineHeight: 1.65, maxWidth: 520 }}>Last updated: 13 August 2026. This policy explains how DigiHR (operated by Sciverse Solutions Pvt. Ltd.) collects, uses and protects your data.</p>
      </div>
    </section>

    <section style={{ padding: '80px 5%' }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>
        {SECTIONS.map(({ title, body }) => (
          <div key={title} style={{ marginBottom: 40 }}>
            <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 12 }}>{title}</h3>
            {body.map((p, i) => (
              <p key={i} style={{ fontSize: 15, color: '#3a3f4a', lineHeight: 1.8, marginBottom: i < body.length - 1 ? 10 : 0 }}>{p}</p>
            ))}
          </div>
        ))}

        <div style={{ padding: 24, background: '#f6f7f9', borderRadius: 20, border: '1px solid #e4e7ed' }}>
          <p style={{ fontSize: 14, color: '#3a3f4a', lineHeight: 1.7 }}>
            <strong>Contact:</strong> For privacy-related queries, write to us at <strong>privacy@digihr.in</strong> or by post to Sciverse Solutions Pvt. Ltd., Office No. 307, Sr No. 18/2 A V18, Pune, Maharashtra 411045, India.
          </p>
        </div>
      </div>
    </section>

    <LandingFooter />
  </>
);

export default PrivacyPolicy;
